export default "__VITE_ASSET__YZg8rPLN__"